import './style.css'
import { remoteAction } from '../../api/endpoints'
import type { RemoteActionType } from '@expostreamer/shared-types'

const remoteStructure: ('placeholder' | RemoteActionType)[][] = [
  ['placeholder', 'arrowup', 'placeholder'],
  ['arrowleft', 'select', 'arrowright'],
  ['placeholder', 'arrowdown', 'placeholder'],
  ['back', 'home', 'dotdotdot'],
]
function Remote() {
  return (
    <div className='remote'>
      {remoteStructure.map(remoteLine => {
        const renderedLine = remoteLine.map(lineItem => {
          if (lineItem === 'placeholder') return <div className='placeholder'></div>
          const src = './remote/' + lineItem + '.svg'
          return (
            <img
              className='zoom'
              id={lineItem}
              src={src}
              onClick={() => {
                remoteAction(lineItem)
              }}
            />
          )
        })

        return <div className='remoteRow'>{renderedLine}</div>
      })}
    </div>
  )
}

export default Remote
